export default Object.freeze([
  {
    id: 'en',
    label: 'English',
    icon: 'language font-20 mr-3',
    isButtonType: true,
  },
  {
    id: 'es',
    label: 'Español',
    icon: 'language font-20 mr-3',
    isButtonType: true,
  },
]);
